const getters = {
  teacherProfile: state => state.teacherProfile,
};

export default getters;
